<template>
  <div class="login-back">
    <div class="login-content">
      <div class="sysbaner">
        <div class="up">
          医疗机构增补智能评估系统
        </div>
        <div class="down">
          <div class="chinese">
            <span>雷达评估</span> <span>高效管理</span>
          </div>
        </div>
      </div>
      
      <div class="input-info">
        <div class="login-tit">欢迎登录</div>
        <div class="desc">
          <div>{{msg}}</div>
        </div>
        <div >
          <div :style="{marginTop: msg ? '15px' : '50px'}">
            <el-input style="width:300px" v-model.trim="name" placeholder="请输入用户名">
             <template v-slot:prepend>账号</template>
            </el-input>
          </div>
          <div style="margin-top:30px;">
            <el-input style="width:300px" type="password" v-model.trim="password" placeholder="请输入密码">
              <template v-slot:prepend>密码</template>
            </el-input>
          </div>
          <div style="margin-top:50px;">
            <el-button style="width:300px" type="primary" v-on:click="submitlogin">登录</el-button>
          </div>
        </div>        
        <div class="QRcodeContainer">
          <div class="QRcode">
            <img src="../assets/img/service.png" alt="联系客服">
          </div>
          <span class="QRcodeContent">
            扫描添加客服人员微信
          </span>
        </div>
      </div>
    </div>
    <div class="footer">
      北京安龙脉德医学科技有限公司 | <a href="http://beian.miit.gov.cn" target="_blank" style="color:#333;text-decoration:none">京ICP证16041224号</a>&nbsp;|&nbsp;客服支持电话:15201103903
    </div>
  </div>
</template>
<script>
    export default {
        name: "login",
        data: function(){
          return {
            name: '',
            password: '',
            msg: '',
          }
        },
        
        mounted(){
          
        },
        methods:{
          createId(){
             return Math.random().toString(36).substr(2)+ Date.now().toString(36)
          },
          submitlogin() {
             if(!localStorage.getItem("randomId")){
               localStorage.setItem("randomId",this.createId())
             }
             if(this.name==""){
               this.$message({message: '账号不能为空',type: 'warning'});
               return;
             }
             if(this.password==""){
               this.$message({message: '密码不能为空',type: 'warning'});
               return;
             }
             const that = this
             this.axios.post("api/uaa/user/login/byPassword",
               { "loginAccount":this.name,"loginPassword":this.password},
               {headers: {'uidevice':localStorage.getItem("randomId")}}).then(
               function (response) {
                 let rData = response.data;
                 if(rData.code=="00000"){
                   let userModel = rData.model;
                    //封装用户信息。
                    let userInfo = {};
                    let regionArr = []
                    regionArr.push(userModel.userInfo.model.provinceId, userModel.userInfo.model.cityId, userModel.userInfo.model.areaId, userModel.userInfo.model.streetId)
                    userInfo.token=userModel.token;
                    userInfo.user={
                      userName:userModel.userInfo.model.name,
                      id:userModel.userInfo.model.id,
                      role:userModel.userInfo.model.role,
                      provinceId:userModel.userInfo.model.provinceId,
                      cityId:userModel.userInfo.model.cityId,
                      areaId:userModel.userInfo.model.areaId,
                      streetId:userModel.userInfo.model.streetId, 
                      regionArr: regionArr,
                      regionName: userModel.userInfo.model.areaName ? userModel.userInfo.model.areaName : (userModel.userInfo.model.cityName ? userModel.userInfo.model.cityName : userModel.userInfo.model.provinceName),
                      region: userModel.userInfo.model.streetId ? userModel.userInfo.model.streetId : ( userModel.userInfo.model.areaId ? userModel.userInfo.model.areaId : (userModel.userInfo.model.cityId ? userModel.userInfo.model.cityId : userModel.userInfo.model.provinceId))
                    }
                    userInfo.menus=userModel.menus;
                    that.$store.commit("setUserInfo",userInfo);
                    sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                    that.$router.push("/home");
                 }else{
                    that.msg = rData.msg
                  }
               }
             );
           },
          
        },
        watch: {
        }
    }
</script>
<style lang="less" scoped>
  .login-back{
    background:url("../assets/img/login_bg.png")  no-repeat center center;
    background-size:cover;
    height:100%;
    width:100%;
    position: absolute;
  }
  .login-content{
    width:1010px;
    height:480px;
    position: absolute;
    left:50%;
    top:50%;
    margin-left:-500px;
    margin-top:-240px;
  }
  .sysbaner{
    float: left;
    width:600px;
    height:480px;
    background: #08057c59;
    font-family: sans-serif;
    color:white;
    text-align: center;
    .up{
        font-size: 30px;
        margin: 60px 0 252px;
    }
    .down{
        .chinese{
            font-size: 24px;
        }
        .english{
            font-size: 20px;
            margin-top: 12px;
            span{
              margin-left:20px;
            }
        }
    }
  }
  .input-info{
    background-color: white;
    float: left;
    width:400px;
    height:480px;
    text-align: center;
    position: relative;
    .login-tit{
      font-size: 28px;
      margin-top: 52px;
      font-weight: bold;
      color: #1A1A1A;
    }
    .desc{
      margin:25px 0 0 50px;
      font-size: 12px;
      color:#f7883a;
      text-align: left;
    }
    .QRcodeContainer{
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .QRcode{
      width: 70px;
      height: 70px;
    }
    .QRcode img{
      width: 100%;
      height: 100%;
    }
    .QRcodeContent{
      font-size: 12px;
      margin: 0;
      margin-top: 5px;
    }
  }
  .footer{
    color: #333333;
    font-size: 16px;
    text-align: center;
    position:absolute;
    bottom:30px;
    margin: 0 auto;
    width:100%
  }
</style>

